// These are listed by priority so that, when there are multiple reasons for a discount to be excluded, the first one is shown to the user
export enum DiscountExclusionReason {
  DiscountExpired = 'DiscountExpired', // #Discount is no longer applicable
  ScheduledPaymentDateIsAfterDiscountExpiration = 'ScheduledPaymentDateIsAfterDiscountExpiration', // #Payment Scheduled too late
  SupplierUserOverride = 'SupplierUserOverride', // #Supplier user has overridden discount
  NotPaidInFull = 'NotPaidInFull', // #Full amount of bill is not being paid
  PaymentMethodNotDiscountable = 'PaymentMethodNotDiscountable', // #Cards not allowed discount
  NotEnoughDiscountInfo = 'NotEnoughDiscountInfo', // #Not enough discount info in db
}
